module.exports = __webpack_public_path__ + "img/cap_03.2e0212d8.jpg";